import RichTextElementPresets from '../RichTextElement/RichTextElementPresets';

const TabsChildElementPreset = RichTextElementPresets[0];

const presets = [
  TabsChildElementPreset
];
export default presets;
